import gql from 'graphql-tag';

export const DELETE_TOKEN_UNDER_SURVEY = gql`
  mutation deleteToken($token: String!) {
    deleteToken(token: $token) {
      token {
        id
      }
    }
  }
`;
